<template lang="pug">
div(class="d-flex flex-column flex-grow-1 min-h-0 fill-height overflow-hidden")
  div(class=" tw-flex tw-flex-row tw-flex-grow-0 tw-p-4 tw-pb-1 tw-text-left")
    v-row
      v-col
        span(class=" tw-text-2xl text-secondary tw-font-bold tw-capitalize ") {{ $t('Listings.Common.addListing') }}
  div(class=" tw-flex tw-flex-row tw-flex-grow tw-overflow-y-scroll tw-p-4 tw-pl-2 tw-pb-0 tw-mb-0")
    v-row(align-self="start" class=" tw-flex tw-flex-row tw-h-full tw-flex-grow tw-p-2 tw-pt-0  tw-pb-0 tw-mb-0")
      v-col(class="  tw-flex tw-flex-col tw-flex-grow tw-pb-0 tw-mb-0")
        v-stepper(v-model="step" flat elevation="0" class="tw-shadow-none tw-h-full")
          v-stepper-header(class="tw-shadow-none")
            v-stepper-step(:complete="step > 1" step="1" color="indigo accent-1")
              span(class="tw-capitalize") {{ $t('Listings.Common.location') }}

            v-divider

            v-stepper-step(:complete="step > 2" step="2" color="indigo accent-1")
              span(class="tw-capitalize") {{ $t('Common.description') }}

            v-divider

            v-stepper-step(step="3" color="indigo accent-1")
              span(class="tw-capitalize") {{ $t('Listings.Common.transaction') }}

          v-stepper-items(class="tw-h-full")
            v-stepper-content(step="1" class="tw-my-0 tw-py-0")
              v-form(ref="form" v-model="isStep1Valid" lazy-validation @keyup.native.enter="valid && submit($event)")
                v-container(fluid class="tw-px-6 tw-mt-0")
                  v-row
                    v-col(cols="7")
                      v-row
                        v-col(class="tw-pt-0")
                          gmap-autocomplete(
                            v-model="address"
                            class="IntroInput"
                            selectFirstOnEnter
                            @place_changed="setAddress"
                          )
                            template(v-slot:input="slotProps")
                              v-text-field(
                                v-model="address"
                                :placeholder="$t('Listings.Common.addressPlaceholder')"
                                ref="input"
                                hide-details
                                v-on:listeners="slotProps.listeners"
                                color="primary"
                              )
                      v-row
                        v-col(cols="9")
                          v-text-field(
                            v-model="form.address_street"
                            :disabled="!address"
                            outlined
                            hide-details
                            :label="$t('Common.street')"
                          )
                        v-col(cols="3")
                          v-text-field(
                            v-model="form.address_street_number"
                            :disabled="!address"
                            outlined
                            hide-details
                            :label="$t('Common.number')"
                          )
                      v-row(v-if="form.address_extended_address" class="tw-py-0 tw-my-0")
                        v-col
                          v-text-field(
                            v-model="form.address_extended_address"
                            :disabled="!address"
                            outlined
                            hide-details
                            :label="$t('Common.extendedAddress')"
                          )
                      v-row
                        v-col
                          v-text-field(
                            v-model="form.addresss_block"
                            :disabled="!address"
                            outlined
                            hide-details
                            :label="$t('Common.block')"
                          )
                        v-col
                          v-text-field(
                            v-model="form.address_floor"
                            :disabled="!address"
                            outlined
                            hide-details
                            :label="$t('Common.floor')"
                          )
                        v-col
                          v-text-field(
                            v-model="form.address_door"
                            :disabled="!address"
                            outlined
                            hide-details
                            :label="$t('Common.door')"
                          )

                      v-row
                        v-col
                          v-text-field(
                            v-model="form.address_city"
                            :disabled="!address"
                            outlined
                            hide-details
                            :label="$t('Common.city')"
                          )

                        v-col
                          v-text-field(
                            v-model="form.address_state"
                            :disabled="!address"
                            outlined
                            hide-details
                            :label="$t('Common.state')"
                          )

                      v-row
                        v-col
                          v-text-field(
                            v-model="form.address_country"
                            :disabled="!address"
                            outlined
                            hide-details
                            :label="$t('Common.country')"
                          )

                        v-col
                          v-text-field(
                            v-model="form.address_zip_code"
                            :disabled="!address"
                            outlined
                            hide-details
                            :label="$t('Common.zipCode')"
                          ) 
                    v-col(cols="5")
                      kubiqa-misc-map(:key="key" mapHeight="360px" :position="position")

            v-stepper-content(step="2")
              v-form(
                ref="formStep2"
                v-model="isStep2Valid"
                lazy-validation
                @keyup.native.enter="valid && submit($event)"
              )
                v-container(fluid class="tw-px-6")
                  v-row
                    v-col
                      v-row
                        v-col
                          v-text-field(
                            v-model="form.name"
                            :label="$t('Common.name')"
                            :rules="nameRules"
                            color="blue darken-4"
                            required
                            hide-details
                            class="tw-mb-4"
                            outlined
                          )
                      v-row(class="tw-pt-1 tw-mb-1")
                        v-col(class="tw-mb-1 tw-pb-1")
                          v-textarea(
                            v-model="form.description"
                            :label="$t('Common.description')"
                            :rules="descriptionRules"
                            color="blue darken-4"
                            required
                            no-resize
                            rows="7"
                            hide-details
                            outlined
                            height="200"
                          )
                    v-col
                      v-row
                        v-col
                          v-select(
                            v-model="form.type"
                            :label="$t('Listings.Common.propertyType')"
                            :items="listingTypes"
                            :menu-props="menuProps"
                            outlined
                            hide-details
                            class="tw-capitalize"
                          )
                        v-col
                          v-text-field(
                            v-model="form.year_built"
                            :label="$t('Listings.Common.yearBuilt')"
                            outlined
                            hide-details
                            class="tw-capitalize"
                          ) 
                      v-row(class="tw-pt-1")
                        v-col
                          v-text-field(
                            v-model="form.construction_size"
                            :label="$t('Listings.Common.constructionSize')"
                            outlined
                            hide-details
                            class="tw-capitalize"
                          )
                        v-col
                          v-text-field(
                            v-model="form.plot_size"
                            :label="$t('Listings.Common.plotSize')"
                            outlined
                            hide-details
                            class="tw-capitalize"
                          )
                      v-row(justify="space-around" class="tw-pt-1")
                        v-col
                          v-select(
                            v-model="form.bedrooms"
                            :label="$t('Listings.Common.bedrooms')"
                            :items="quantity"
                            :menu-props="menuProps"
                            outlined
                            hide-details
                            class="tw-capitalize"
                          )

                        v-col
                          v-select(
                            v-model="form.bathrooms"
                            :label="$t('Listings.Common.bathrooms')"
                            :items="quantity"
                            :menu-props="menuProps"
                            outlined
                            hide-details
                            class="tw-capitalize"
                          )
                      v-row(justify="space-around" class="tw-pt-1")
                        v-col
                          v-select(
                            v-model="form.parking_spaces"
                            :label="$t('Listings.Common.parkingSpaces')"
                            :items="quantity"
                            :menu-props="menuProps"
                            outlined
                            hide-details
                            class="tw-capitalize"
                          )

                        v-col
                          v-select(
                            v-model="form.floors"
                            :label="$t('Listings.Common.floors')"
                            :items="quantity"
                            :menu-props="menuProps"
                            outlined
                            hide-details
                            class="tw-capitalize"
                          )

            v-stepper-content(step="3" class="tw-h-full  tw-m-0 tw-py-0 ")
              v-form(
                ref="formStep3"
                v-model="isStep3Valid"
                lazy-validation
                @keyup.native.enter="valid && submit($event)"
              )
                div(class="  tw-h-full")
                  v-row(class="tw-h-full")
                    v-col(cols="12" class="tw-h-full")
                      v-row(justify="center" align="stretch" class="tw-h-full ")
                        v-col(
                          class="tw-border tw-border-gray-lighten-2 tw-rounded-md tw-mb-10 tw-m-4 tw-overflow-hidden tw-py-0"
                        )
                          v-row(class="tw-bg-gray-lighten-4")
                            v-col(class="tw-py-2 tw-pb-4")
                              v-row(align="center")
                                v-col(cols="auto")
                                  v-checkbox(
                                    v-model="form.sale_enabled"
                                    hide-details
                                    color="indigo accent-1"
                                    :ripple="false"
                                    outlined
                                    class="tw-font-bold tw-text-3xl "
                                  )
                                v-col(class="tw--ml-6")
                                  div(class="tw-pt-5")
                                    span(class="tw-font-bold tw-text-xl tw-capitalize") {{ $t('Listings.Common.forSale') }}

                          v-row(class="tw-pt-4 tw-px-8")
                            v-col
                              v-text-field(
                                :disabled="!form.sale_enabled"
                                v-model="form.sale_price"
                                outlined
                                :label="$t('Listings.Common.price')"
                                class="tw-capitalize"
                              )

                            v-col
                              v-select(
                                :disabled="!form.sale_enabled"
                                v-model="form.sale_currency"
                                :items="currencies"
                                outlined
                                :menu-props="menuProps"
                                :label="$t('Listings.Common.currency')"
                                class="tw-capitalize"
                              )

                        v-col(
                          class="tw-border tw-border-gray-lighten-2 tw-rounded-md tw-mb-10 tw-m-4 tw-overflow-hidden tw-py-0"
                        )
                          v-row(class="tw-bg-gray-lighten-4")
                            v-col(class="tw-py-2 tw-pb-4")
                              v-row(align="center")
                                v-col(cols="auto")
                                  v-checkbox(
                                    v-model="form.rent_enabled"
                                    hide-details
                                    outlined
                                    color="indigo accent-1"
                                    :ripple="false"
                                    class="tw-font-bold tw-text-3xl "
                                  )
                                v-col(class="tw--ml-6")
                                  div(class="tw-pt-5")
                                    span(class="tw-font-bold tw-text-xl tw-capitalize") {{ $t('Listings.Common.forRent') }}

                          v-row(class="tw-pt-4 tw-px-8")
                            v-col
                              v-text-field(
                                :disabled="!form.rent_enabled"
                                v-model="form.rent_price"
                                :label="$t('Listings.Common.price')"
                                :suffix="'/' + $t('Listings.Common.month')"
                                outlined
                                class="tw-capitalize"
                              )

                            v-col
                              v-select(
                                :disabled="!form.rent_enabled"
                                v-model="form.rent_currency"
                                :items="currencies"
                                :menu-props="menuProps"
                                :label="$t('Listings.Common.currency')"
                                outlined
                                class="tw-capitalize"
                              )

  div(class="tw-flex tw-flex-row tw-flex-grow-0 tw-p-4 tw-pt-1")
    v-row(justify="end" align-self="end" align="end" class="tw-bottom-0")
      v-col(cols="auto" class="tw-h-full fill-height")
        span(v-if="!loading")
          v-btn(
            v-if="step > 1"
            :ripple="false"
            @click="back"
            plain
            color="indigo"
            class="tw-mr-2 tw-mb-0"
          )
            span(class="tw-font-bold") {{ $t('Common.back') }}
        v-btn(
          v-if="step == 1"
          depressed
          color="rgba(94,129,244,0.80)"
          @click="validateStep1"
          width="90px"
        )
          span(class="tw-font-bold") {{ $t('Common.next') }}
        v-btn(
          v-if="step == 2"
          depressed
          color="rgba(94,129,244,0.80)"
          @click="validateStep2"
          width="90px"
        )
          span(class="tw-font-bold") {{ $t('Common.next') }}
        v-btn(
          v-if="step == 3"
          depressed
          color="rgba(94,129,244,0.80)"
          :loading="loading"
          @click="submit"
          width="90px"
        )
          span(class="tw-font-bold") {{ $t('Common.save') }}
</template>
<script>
export default {
  data() {
    return {
      form: {
        name: '',
        description: '',
        type: '',
        year_built: '',
        construction_size: '',
        plot_size: '',
        bedrooms: '',
        bathrooms: '',
        parking_spaces: '',
        floors: '',

        address_street: '',
        address_street_number: '',
        address_extended_address: '',
        address_block: '',
        address_floor: '',
        address_door: '',
        address_city: '',
        address_state: '',
        address_country: '',
        address_zip_code: '',
        address_latitude: '',
        address_longitude: '',

        sale_enabled: false,
        sale_price: '',
        sale_currency: '',

        rent_enabled: false,
        rent_price: '',
        rent_currency: '',
      },
      isStep1Valid: false,
      isStep2Valid: false,
      isStep3Valid: false,
      loading: false,
      step: 1,
      address: '',
      position: {},
      key: 1,
      currencies: ['USD', 'MXN', 'CAD', 'EUR'],
      listingTypes: ['House', 'Appartment', 'Office Space', 'Plot'],
      quantity: ['1', '2', '3', '4', '5+'],
      nameRules: [(v) => !!v || 'Please enter a title for this listing'],
      descriptionRules: [(v) => !!v || 'Please enter a title for this listing'],

      menuProps: {
        maxHeight: '120px',
        overflowyY: true,
      },
    };
  },
  mounted() {
    this.key = ++this.key;
  },
  methods: {
    save() {
      console.log(this.form);
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.error = true;
        this.error_message = 'error';
      }
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    setAddress(address) {
      (this.form.address_street = ''),
        (this.form.address_street_number = ''),
        (this.form.address_extended_address = ''),
        (this.form.address_city = ''),
        (this.form.address_state = ''),
        (this.form.address_country = ''),
        (this.form.address_zip_code = ''),
        (this.address = address.formatted_address);
      this.key += this.key;
      this.position.lat = address.geometry.location.lat();
      this.position.lng = address.geometry.location.lng();
      this.form.address_latitude = address.geometry.location.lat();
      this.form.address_longitude = address.geometry.location.lng();
      for (let i = 0; i < address.address_components.length; i++) {
        const componentType = address.address_components[i].types[0];
        switch (componentType) {
          case 'street_number':
            this.form.address_street_number = address.address_components[i].long_name;
            break;

          case 'route':
            this.form.address_street = address.address_components[i].long_name;
            break;

          case 'sublocality_level_1':
            this.form.address_extended_address = address.address_components[i].long_name;
            break;

          case 'locality':
            this.form.address_city = address.address_components[i].long_name;
            break;

          case 'administrative_area_level_1':
            this.form.address_state = address.address_components[i].long_name;
            break;

          case 'country':
            this.form.address_country = address.address_components[i].long_name;
            break;

          case 'postal_code':
            this.form.address_zip_code = address.address_components[i].long_name;
            break;
        }
      }
    },
    refresh() {
      this.key += this.key;
    },
    next() {
      this.$refs.form.validate();
      console.log(this.$refs.form.validate());
      if (this.valid) {
        return (this.step = ++this.step);
      }
      //return (this.step = ++this.step);
    },
    validateStep1() {
      this.$refs.form.validate();
      if (this.isStep1Valid) {
        return (this.step = ++this.step);
      }
    },
    validateStep2() {
      if (this.$refs.formStep2.validate()) {
        return (this.step = ++this.step);
      }
    },
    back() {
      if (this.step > 1) {
        return (this.step = --this.step);
      }
    },
    submit() {
      if (this.$refs.formStep3.validate()) {
        this.loading = true;
        console.log(this.form);

        this.$store
          .dispatch('properties/addProperty', this.form)
          .then((response) => {
            this.$store.dispatch('properties/getProperties');
            this.$store.getters['properties/properties'];
            this.$emit('close');
            this.loading = false;
            this.$refs.form.reset();
          })

          .catch((error) => {
            this.error = true;
            console.log(this.$store.state.error);
            this.error_message = this.$store.state.error;
          });
      }
    },
  },
};
</script>

<style lang="css">
.v-stepper__wrapper {
  height: 100%;
}
</style>
